import axios from "axios";

//const
const EQUIPMENT_BACKUP_DETAIL_UPDATE_DATA = "equipmentBackupDetail/EQUIPMENT_BACKUP_DETAIL_UPDATE_DATA";
const EQUIPMENT_BACKUP_DETAIL_STORE_CONFIG = "equipmentBackupDetail/EQUIPMENT_BACKUP_DETAIL_STORE_CONFIG";
const EQUIPMENT_BACKUP_DETAIL_STORE_DATA = "equipmentBackupDetail/EQUIPMENT_BACKUP_DETAIL_STORE_DATA";
const EQUIPMENT_BACKUP_DETAIL_TOGGLE_LOADING = "equipmentBackupDetail/EQUIPMENT_BACKUP_DETAIL_TOGGLE_LOADING";

//reducer
export const equipmentBackupDetail = (state = {
  loading: false,

  equipmentId: "",
  equipmentConfig: [],
  equipmentData: [],
  nodes: [],

  name: "",
  alias: "",
  startTime: null,
  endTime: null,
}, action) => {
  switch (action.type) {
    case EQUIPMENT_BACKUP_DETAIL_UPDATE_DATA:
      return {
        ...state,
        [action.data.name]: action.data.value
      };
    case EQUIPMENT_BACKUP_DETAIL_STORE_CONFIG:
      return {
        ...state,
        equipmentConfig: action.data,
        nodes: action.data.collectNodeConfigs || [],
        equipmentData: [],
        name: "",
        alias: "",
        startTime: "",
        endTime: "",
      };
    case EQUIPMENT_BACKUP_DETAIL_STORE_DATA:
      return {
        ...state,
        equipmentData: action.data
      };
    case EQUIPMENT_BACKUP_DETAIL_TOGGLE_LOADING:
      return {
        ...state,
        loading: action.data
      };
    default:
      return state
  }
};

/**
 * update data based on user input
 */
export const updateEquipmentBackupDetailData = (data) => {
  return {
    type: EQUIPMENT_BACKUP_DETAIL_UPDATE_DATA,
    data: data
  }
};

/**
 * check and init equipment data
 */
export const initEquipmentBackupDetail = (equipmentId) => (dispatch) => {
  if (equipmentId !== null && equipmentId !== undefined && equipmentId !== "") {
    dispatch(updateEquipmentBackupDetailData({
      name: "equipmentId",
      value: equipmentId
    }));
    dispatch(toggleLoading(true));
    axios.get(`/api-equipment/getEquipmentConfigByEquipmentId/${equipmentId}`, {contentType: "application/json"}).then(
      response => {
        if (response.data) {
          dispatch(storeEquipmentConfig(response.data));
        } else {
          dispatch(storeEquipmentConfig([]));
        }
        dispatch(toggleLoading(false));
      }
    );
  } else {
    dispatch(toggleLoading(false));
    this.props.history.push("/exception/415");
  }
};

/**
 * store all equipment config
 */
export const storeEquipmentConfig = (equipmentConfig) => {
  return {
    type: EQUIPMENT_BACKUP_DETAIL_STORE_CONFIG,
    data: equipmentConfig
  }
};

/**
 * store all equipment history data
 */
export const storeEquipmentData = (equipmentData) => {
  return {
    type: EQUIPMENT_BACKUP_DETAIL_STORE_DATA,
    data: equipmentData
  }
};

/**
 * toggle loading
 */
export const toggleLoading = (show) => {
  return {
    type: EQUIPMENT_BACKUP_DETAIL_TOGGLE_LOADING,
    data: show
  }
};

